<template>
  <div>
    <template v-if="!diagnosisProjectPrint">
      <div class="receipt" style="font-family: '微软雅黑';">
        <div class="page" id='scriptInfo-others'>
          <!-- 处方信息 -->
          <div style="font-size: 8pt; line-height: 16pt;height: 16pt;">
            <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
            <div style="float: right;">
              <p style="display: inline-block;float: right;">
                <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
              </p>
              <p
                  style="width: 25pt;float: right; text-align:center;height: 14pt;line-height: 12pt;border:1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 8pt;">
                普通</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;">{{ printConfig.titleName
          || $store.state.global.countInfo.hospitalName }}
          </h3>
          <h4 style="text-align: center; font-size: 12pt;margin-top: -16pt;">诊疗费用单</h4>
          <div class="user-info" style="margin-top: -10pt;font-size: 9pt;font-family: '微软雅黑';">
            <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                姓名：{{ record.patient.patientName }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                年龄：
                <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
                <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                  record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;; line-height: 24pt;height: 24pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                手机号：{{ record.patient.phoneNo }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                科室：{{ record.inquiryInfo.laboratoryName }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                就诊日期：{{ record.inquiryInfo.clinicalTime }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;line-height: 24pt;">
              <div>
                临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
              <div>
                过敏史：{{ record.inquiryInfo.allergyHistory }}
              </div>
            </div>
          </div>
        </div>
        <!-- 处方 -->
        <div class="page" id="idAdd-others">
          <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
                 style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';">
            <TBODY>
            <TR>
              <TD>
                <div style="line-height: 20pt;">检查治疗项：
                  <span v-for="(item, index) in record.examList" :key="index">
                  {{ item.examName }}
                  {{ item.total }} 次；
                </span>
                </div>
                <div style="line-height: 20pt;">附加费用：{{ record.additionalList | jionArr }}</div>
              </TD>
            </TR>
            </TBODY>
          </TABLE>
        </div>
        <div class="page" id="idAdd-others1">
          <table border=0 cellSpacing=0 cellPadding=1 width="100%"
                 style="border-collapse:collapse;font-size: 10pt;font-family: '微软雅黑';">
            <tbody>
            <tr>
              <td>
                <div style="width: 100%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;">
                  <div style="width: 20%;">项目名称</div>
                  <div style="width: 20%;">数量</div>
                  <div style="width: 20%;">单位</div>
                  <div style="width: 20%;">单价</div>
                  <div style="width: 20%;">金额</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="width: 100%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;font-size: 9pt;"
                     v-for="(it, index) in record.patientItemDiagnosisList" :key="index">
                  <div style="width: 20%;">{{ it.itemName}}</div>
                  <div style="width: 20%;">{{ it.totalNum}} </div>
                  <div style="width: 20%;">{{ it.saleUnit}} </div>
                  <div style="width: 20%;">￥{{ it.salePrice || 0 }} </div>
                  <div style="width: 20%;">￥{{ it.totalPrice || (Number(it.totalNum) * Number(it.salePrice)).toFixed(2) || 0 }}</div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- 诊所信息 -->
        <div style="margin-top: 0pt;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-others">
          <div style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;">
            <div style="width: 49.99%; float: left;">
              医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
              <!-- 医生：<span>{{record.realName}}</span> -->
            </div>
            <div style="width: 49.99%; float: left;">
              诊疗总金额：<span>￥{{ otherAmt }}</span>
            </div>
          </div>
          <div style="clear: both;"></div>
          <p style="font-size: 9pt;margin-top: 4pt;font-family: '微软雅黑';">打印时间：{{ printTime }}</p>
        </div>
      </div>
    </template>

    <!-- 分开打印  -->
    <template v-else>
      <div class="receipt" style="font-family: '微软雅黑';">
        <div class="page" id='scriptInfo-others'>
          <!-- 处方信息 -->
          <div style="font-size: 8pt; line-height: 16pt;height: 16pt;">
            <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
            <div style="float: right;">
              <p style="display: inline-block;float: right;">
                <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
              </p>
              <p
                  style="width: 25pt;float: right; text-align:center;height: 14pt;line-height: 12pt;border:1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 8pt;">
                普通</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;">{{ printConfig.titleName
          || $store.state.global.countInfo.hospitalName }}
          </h3>
          <h4 style="text-align: center; font-size: 12pt;margin-top: -16pt;">{{ !title ? "诊疗费用单" : title + '单' }}</h4>
          <div class="user-info" style="margin-top: -10pt;font-size: 9pt;font-family: '微软雅黑';">
            <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                姓名：{{ record.patient.patientName }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                年龄：
                <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
                <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                  record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;; line-height: 24pt;height: 24pt;">
              <div style="display: inline-block;width: 33.333%; float: left;">
                手机号：{{ record.patient.phoneNo }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                科室：{{ record.inquiryInfo.laboratoryName }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
                就诊日期：{{ record.inquiryInfo.clinicalTime }}
              </div>
              <div style="display: inline-block;width: 33.333%; float: left;">
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;line-height: 24pt;">
              <div>
                临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
              </div>
            </div>
            <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
              <div>
                过敏史：{{ record.inquiryInfo.allergyHistory }}
              </div>
            </div>
          </div>
        </div>
        <!-- 处方 -->
        <div class="page" id="idAdd-others">
          <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
                 style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';">
            <TBODY>
            <TR>
              <TD>
                <div style="line-height: 20pt;">检查治疗项：
                  <span v-for="(item, index) in record.examList" :key="index">
                  {{ item.examName }}
                  {{ item.total }} 次；
                </span>
                </div>
                <div style="line-height: 20pt;">附加费用：{{ record.additionalList | jionArr }}</div>
              </TD>
            </TR>
            </TBODY>
          </TABLE>
        </div>
        <div class="page" id="idAdd-others1">
          <table border=0 cellSpacing=0 cellPadding=1 width="100%"
                 style="border-collapse:collapse;font-size: 10pt;font-family: '微软雅黑';">
            <tbody>
            <tr>
              <td>
                <div style="width: 100%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;">
                  <div style="width: 20%;">项目名称</div>
                  <div style="width: 20%;">数量</div>
                  <div style="width: 20%;">单位</div>
                  <div style="width: 20%;">单价</div>
                  <div style="width: 20%;">金额</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="width: 100%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;font-size: 9pt;"
                     v-for="(it, index) in record.patientItemDiagnosisList" :key="index">
                  <div style="width: 20%;">{{ it.itemName}}</div>
                  <div style="width: 20%;">{{ it.totalNum}} </div>
                  <div style="width: 20%;">{{ it.saleUnit}} </div>
                  <div style="width: 20%;">￥{{ it.salePrice || 0 }} </div>
                  <div style="width: 20%;">￥{{ it.totalPrice || (Number(it.totalNum) * Number(it.salePrice)).toFixed(2) || 0 }}</div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- 诊所信息 -->
        <div style="margin-top: 0pt;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-others">
          <div style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;">
            <div style="width: 49.99%; float: left;">
              医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
              <!-- 医生：<span>{{record.realName}}</span> -->
            </div>
            <div style="width: 49.99%; float: left;">
              诊疗总金额：<span>￥{{ otherAmt }}</span>
            </div>
          </div>
          <div style="clear: both;"></div>
          <p style="font-size: 9pt;margin-top: 4pt;font-family: '微软雅黑';">打印时间：{{ printTime }}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /** 
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
  */
  props: {
    record: {
      type: Object,
      default: {
        patient: {
          patientName: ''
        },
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    },
    // 是否分页
    diagnosisProjectPrint: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      curType: 'other',
      title: "",//标题,
      copyRecord: {},//备份传递的数据
    }
  },
  computed: {
    laboratoryName() {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    addAmt() {
      if (!this.record.additionalList || this.record.additionalList.length === 0) return 0;
      const subAdditionalList = this.record.additionalList.reduce((a, b) => {
        return a + Number(b.additionalPrice);
      }, 0); // 附加费用总和
      return BN(subAdditionalList).toFixed(2);
    },
    examAmt() {
      if (!this.record.examList || this.record.examList.length === 0) return 0;
      const sub = this.record.examList.reduce((a, b) => {
        const salePrice = Number(b.price);
        const dosage = Number(b.total);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.price).multipliedBy(b.total).toFixed(2);
        }
        return a + Number(result);
      }, 0);
      return sub;
    },
    patientItemDiagnosis() {
      if (!this.record.patientItemDiagnosisList || this.record.patientItemDiagnosisList.length === 0) return 0;
      const sub = this.record.patientItemDiagnosisList.reduce((a, b) => {
        return a + Number(b.totalPrice || (Number(b.totalNum) * Number(b.salePrice)).toFixed(0));
      }, 0);
      return sub;
    },
    otherAmt () {
      return BN(this.addAmt).plus(this.examAmt).plus(this.patientItemDiagnosis).toFixed(2);
    },
  },
  watch: {
    record() {
      this.copyRecord = JSON.parse(JSON.stringify(this.record));
    }
  },
  // created() {
  //   this.copyRecord = JSON.parse(JSON.stringify(this.record));
  // },
  methods: {
    // 打印设置
    print({ isReview, typeIndex = -1, title, itemType } = {}) {
      this.title = title;
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { otherValue } = this.$store.state.global.printConfig;

      let patientItemDiagnosisList = []
      // 处理直接售药
      if (typeIndex === -1) {
        this.copyRecord.patientItemDiagnosisList && this.copyRecord.patientItemDiagnosisList.forEach((itemOne)=>{
          if(itemOne.items && itemOne.items.length > 0) {
            itemOne.items.forEach((itemTwo)=>{
              patientItemDiagnosisList.push(itemTwo)
            })
          }
        })

        if(patientItemDiagnosisList.length > 0) {
          this.copyRecord.patientItemDiagnosisList = patientItemDiagnosisList;
        }

        this.record.patientItemDiagnosisList = this.copyRecord.patientItemDiagnosisList &&  this.copyRecord.patientItemDiagnosisList;

        this.$nextTick(() => {
          const LODOP = getLodop();
          LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
          LODOP.PRINT_INIT('其他处方打印');
          LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '其他处方打印');
          LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('scriptInfo-others').innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
          console.log(this.record)
          if(this.record.examList && this.record.examList.length > 0) {
            LODOP.ADD_PRINT_HTM('65mm', '5%', '90%', '110mm', document.getElementById('idAdd-others').innerHTML);
          } else if(this.record.patientItemDiagnosisList && this.record.patientItemDiagnosisList.length > 0) {
            LODOP.ADD_PRINT_HTM('65mm', '5%', '90%', '110mm', document.getElementById('idAdd-others1').innerHTML);
          }
          LODOP.ADD_PRINT_HTM('170mm', '5%', '90%', '50mm', document.getElementById('footer-info-others').innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
          LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
          LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); //打印后自动关闭预览窗口
          LODOP.SET_PRINTER_INDEX(otherValue);
          // LODOP.PREVIEW();
          // if (isReview) {
          LODOP.PREVIEW();
          // } else {
          //   LODOP.PRINT();
          // }
        });
      } else {
        this.copyRecord.patientItemDiagnosisList.forEach((itemOne)=>{
          if(itemOne.items && itemOne.items.length > 0) {
            itemOne.items.forEach((itemTwo)=>{
              patientItemDiagnosisList.push(itemTwo)
            })
          }
        })

        if(patientItemDiagnosisList.length > 0) {
          this.copyRecord.patientItemDiagnosisList = patientItemDiagnosisList;
        }

        this.record.patientItemDiagnosisList = this.copyRecord.patientItemDiagnosisList.filter(item => item.itemType === itemType);

        this.$nextTick(() => {
          const LODOP = getLodop();
          LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
          LODOP.PRINT_INIT('其他处方打印');
          LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '其他处方打印');
          LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('scriptInfo-others').innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
          console.log(this.record)
          if(this.record.examList && this.record.examList.length > 0) {
            LODOP.ADD_PRINT_HTM('65mm', '5%', '90%', '110mm', document.getElementById('idAdd-others').innerHTML);
          } else if(this.record.patientItemDiagnosisList && this.record.patientItemDiagnosisList.length > 0) {
            LODOP.ADD_PRINT_HTM('65mm', '5%', '90%', '110mm', document.getElementById('idAdd-others1').innerHTML);
          }
          LODOP.ADD_PRINT_HTM('170mm', '5%', '90%', '50mm', document.getElementById('footer-info-others').innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
          LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
          LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); //打印后自动关闭预览窗口
          LODOP.SET_PRINTER_INDEX(otherValue);
          // LODOP.PREVIEW();
          // if (isReview) {
          LODOP.PREVIEW();
          // } else {
          //   LODOP.PRINT();
          // }
        });
      }
    },
    // 计算金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    }
  },
  filters: {
    jionArr(arr) {
      if (!Array.isArray(arr)) return;
      return arr.map(item => item.additionalName).join(',');
    },
  },
  mounted() {
    this.getPrintConfig();//获取打印配置
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2pt solid #000000;
}

.receipt {
  width: 300pt;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 20pt;
  height: 20pt;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000pt;
  left: 100pt;
  background: white;
  left: -5000pt;
  top: 100pt;
}
</style>
